import { BlurFilter, ColorMatrixFilter, Sprite } from "pixi.js";
import type { Container } from "pixi.js";

/** Owns only the blurred hull copy; ship textures and shader programs remain shared. */
export class ShipSilhouetteGlow {
  private sprite: Sprite | null = null;
  private filter: BlurFilter | null = null;
  private colorize: ColorMatrixFilter | null = null;
  private color: number | null = null;

  constructor(
    private readonly heading: Container,
    private readonly hull: Sprite,
  ) {}

  sync(color: number | null): void {
    if (color === null) {
      if (this.sprite) this.sprite.visible = false;
      return;
    }
    if (!this.sprite) {
      this.filter = new BlurFilter({
        strength: 6,
        quality: 2,
        resolution: 1,
        blendMode: "add",
      });
      this.colorize = new ColorMatrixFilter();
      this.sprite = new Sprite({ texture: this.hull.texture });
      this.sprite.label = "selection-glow";
      this.sprite.filters = [this.colorize, this.filter];
      this.sprite.blendMode = "add";
      this.sprite.alpha = 0.9;
      this.sprite.eventMode = "none";
      this.heading.addChildAt(
        this.sprite,
        this.heading.getChildIndex(this.hull),
      );
    }
    this.sprite.texture = this.hull.texture;
    this.sprite.anchor.copyFrom(this.hull.anchor);
    this.sprite.position.copyFrom(this.hull.position);
    this.sprite.scale.copyFrom(this.hull.scale);
    this.sprite.pivot.copyFrom(this.hull.pivot);
    this.sprite.skew.copyFrom(this.hull.skew);
    this.sprite.rotation = this.hull.rotation;
    if (this.colorize && this.color !== color) {
      // Replace RGB while retaining texture alpha, including dark hull edges.
      this.colorize.matrix = [
        0,
        0,
        0,
        0,
        ((color >> 16) & 255) / 255,
        0,
        0,
        0,
        0,
        ((color >> 8) & 255) / 255,
        0,
        0,
        0,
        0,
        (color & 255) / 255,
        0,
        0,
        0,
        1,
        0,
      ];
      this.color = color;
    }
    this.sprite.visible = true;
  }

  destroy(): void {
    if (this.sprite) {
      this.sprite.filters = null;
      this.sprite.destroy();
      this.sprite = null;
    }
    if (this.filter) {
      this.filter.blurXFilter.destroy();
      this.filter.blurYFilter.destroy();
      this.filter.destroy();
      this.filter = null;
    }
    this.colorize?.destroy();
    this.colorize = null;
    this.color = null;
  }
}
